"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, Flex } from "@opensea/ui-kit";
import { ItemMetadataChip } from "./ItemMetadataChip";
import { ItemMetadataChipsFragment } from "./ItemMetadataChips.fragment";
export function ItemMetadataChips(t0) {
  const $ = _c(14);
  const {
    className,
    item: itemKey,
    chips: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? ["standard", "chain", "token_id", "owners"] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const chips = t2;
  let t3;
  if ($[2] !== itemKey) {
    t3 = readFragment(ItemMetadataChipsFragment, itemKey);
    $[2] = itemKey;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const item = t3;
  let t4;
  if ($[4] !== className) {
    t4 = classNames("scrollbar-hidden w-full gap-2 overflow-auto", className);
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== chips || $[7] !== item) {
    let t6;
    if ($[9] !== item) {
      t6 = chip => <ItemMetadataChip chip={chip} item={item} key={chip} />;
      $[9] = item;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = chips.map(t6);
    $[6] = chips;
    $[7] = item;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Flex className={t4}>{t5}</Flex>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}